import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from 'gematik-form-library';
import { Observable } from 'rxjs';

export interface SteResponse {
  answered: boolean;
  confidence: number;
  answer: string;
  logId: number;
}

@Injectable({
  providedIn: 'root',
})
export class SteService {
  constructor(
    private http: HttpClient,
    private env: EnvService,
  ) {}

  submitSupportRequest(query: string): Observable<SteResponse> {
    return this.http.post<SteResponse>(`${this.env.chatbotBackendUrl}/ste`, { query });
  }

  submitFeedback(logId: number, helpful: boolean): Observable<void> {
    return this.http.post<void>(`${this.env.chatbotBackendUrl}/ste/feedback`, { logId, helpful });
  }
}
